import { useEffect, useRef, useCallback } from 'react';
import { useSocketStore } from '../../stores/useSocketStore';
import { useTripAnalysisSubscriptionStore } from '../../stores/analysis/useTripAnalysisSubscriptionStore';

export function useTripAnalysisSubscriptions() {

    const subscriptions = useTripAnalysisSubscriptionStore(
        state => state.subscriptions
    );

    const socket = useSocketStore(
        state => state.socket
    );

    const previousSubscriptions = useRef(new Map());

    const socketSubscriptions = useCallback(() => {

        if (!socket?.connected) return;

        const currentSubscriptions = new Map(
            useTripAnalysisSubscriptionStore
                .getState()
                .subscriptions
        );

        const previous = previousSubscriptions.current;

        const newSubscriptions = [];
        const removedSubscriptions = [];

        for (const [key, subscription] of currentSubscriptions) {

            if (!previous.has(key)) {
                newSubscriptions.push(subscription);
            }

        }

        for (const [key, subscription] of previous) {

            if (!currentSubscriptions.has(key)) {
                removedSubscriptions.push(subscription);
            }

        }

        previousSubscriptions.current = new Map(
            currentSubscriptions
        );

        if (newSubscriptions.length > 0) {

            socket.emit(
                'trip-analysis:join-many',
                {
                    trips: newSubscriptions
                }
            );

        }

        if (removedSubscriptions.length > 0) {

            socket.emit(
                'trip-analysis:leave-many',
                {
                    trips: removedSubscriptions
                }
            );

        }

    }, [socket]);

    useEffect(() => {

        if (!socket) return;

        const handleConnect = () => {

            previousSubscriptions.current = new Map();

            socketSubscriptions();

        };

        socket.on(
            'connect',
            handleConnect
        );

        return () => {

            socket.off(
                'connect',
                handleConnect
            );

        };

    }, [socket, socketSubscriptions]);

    useEffect(() => {

        socketSubscriptions();

    }, [subscriptions, socketSubscriptions]);

}